// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import laoJson from "./messages/lao.json"
import enJson from "./messages/en.json"
import chiJson from "./messages/china.json"

const resources = {
    en: {
        translation: enJson,
    },
    lao: {
        translation: laoJson,
    },
    chi: {
        translation: chiJson,
    },

};

export const normalizeLanguageCode = (lng) => {
    if (!lng || typeof lng !== "string") return undefined;

    const lower = lng.toLowerCase();

    if (lower === "lao" || lower.startsWith("lo")) return "lao";
    if (lower === "en" || lower.startsWith("en-")) return "en";
    if (lower === "chi" || lower.startsWith("zh")) return "chi";

    return lower;
};

const getInitialLanguage = () => {
    let storedLanguage;
    try {
        storedLanguage = localStorage.getItem("i18nextLng");
    } catch (error) {
        storedLanguage = undefined;
    }

    const normalizedStored = normalizeLanguageCode(storedLanguage);
    const initialLanguage = normalizedStored || "lao";
    const supported = initialLanguage === "lao" || initialLanguage === "en" || initialLanguage === "chi";
    const safeLanguage = supported ? initialLanguage : "lao";

    try {
        if (!storedLanguage || !normalizedStored) {
            localStorage.setItem("i18nextLng", safeLanguage);
        } else if (normalizedStored !== storedLanguage) {
            localStorage.setItem("i18nextLng", normalizedStored);
        }
    } catch (error) { }

    return safeLanguage;
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: getInitialLanguage(),
        fallbackLng: 'lao',
        supportedLngs: ["lao", "en", "chi"],
        load: "languageOnly",
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"],
            lookupLocalStorage: "i18nextLng",
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
